/*
 * @Author: dengyong simon.deng@wetax.com.cn
 * @Date: 2022-06-20 15:57:40
 * @LastEditors: dengyong simon.deng@wetax.com.cn
 * @LastEditTime: 2022-06-20 17:44:36
 * @FilePath: /tiangong/src/views/sysmana/permission/utils/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export const offsetTop = (dom, offset = 0) => {
  if (!dom || !dom.offsetParent) return offset
  if (dom.offsetParent.nodeName === 'BODY') return offset
  offset += dom.offsetTop
  offsetTop(dom.offsetParent, offset)
  return offset
}
